exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-green[data-v-0e0d64bc] {\n    color: #00744A;\n}\n", ""]);

// exports
